import React, {Component} from "react";
import {inject, observer} from "mobx-react";
import {toJS} from "mobx";

import {v4 as uuidv4} from "uuid";

import AkindaLogo from "../../assets/img/ak-mob3.svg";
import PhotoSelfieLogo from "../../assets/img/sa/PHOTOSELFIE.png";
import PhotoSelfie from "../../assets/img/sa/selfie_album_top.png";

import '../../assets/css/calendar.css';
import CircularProgress from 'material-ui/Progress/CircularProgress';

import {
    calendar_min_photo_size,
    calendar_max_photo_size,
    calendar_sponsor_min_photo_size,
    calendar_sponsor_max_photo_size,
    PHOTOSELFIE_BASE_URL
} from '../../utils/constants';

@inject('store')
@observer

class UploadCalendar extends Component {

    constructor(props) {

        super(props);

        this.state = {
            calendar_data: {
                january: {
                    calendar_name: '',
                    description: '',
                    sponsor_1: {},
                    sponsor_2: {},
                    photos: []
                },
                february: {
                    calendar_name: '',
                    description: '',
                    sponsor_1: {},
                    sponsor_2: {},
                    photos: []
                },
                march: {
                    calendar_name: '',
                    description: '',
                    sponsor_1: {},
                    sponsor_2: {},
                    photos: []
                },
                april: {
                    calendar_name: '',
                    description: '',
                    sponsor_1: {},
                    sponsor_2: {},
                    photos: []
                },
                may: {
                    calendar_name: '',
                    description: '',
                    sponsor_1: {},
                    sponsor_2: {},
                    photos: []
                },
                june: {
                    calendar_name: '',
                    description: '',
                    sponsor_1: {},
                    sponsor_2: {},
                    photos: []
                },
                july: {
                    calendar_name: '',
                    description: '',
                    sponsor_1: {},
                    sponsor_2: {},
                    photos: []
                },
                august: {
                    calendar_name: '',
                    description: '',
                    sponsor_1: {},
                    sponsor_2: {},
                    photos: []
                },
                september: {
                    calendar_name: '',
                    description: '',
                    sponsor_1: {},
                    sponsor_2: {},
                    photos: []
                },
                october: {
                    calendar_name: '',
                    description: '',
                    sponsor_1: {},
                    sponsor_2: {},
                    photos: []
                },
                november: {
                    calendar_name: '',
                    description: '',
                    sponsor_1: {},
                    sponsor_2: {},
                    photos: []
                },
                december: {
                    calendar_name: '',
                    description: '',
                    sponsor_1: {},
                    sponsor_2: {},
                    photos: []
                }
            },
            errors: {
                calendar_logo: {},
                january: {},
                february: {},
                march: {},
                april: {},
                may: {},
                june: {},
                july: {},
                august: {},
                september: {},
                october: {},
                november: {},
                december: {}
            },
            url_ok: '',
            // language: '',
            months: ['january', 'february', 'march', 'april', 'may', 'june', 'july', 'august', 'september', 'october', 'november', 'december'],
            // months: ['january'],
            logo_uploaded_ok: false,
            show_upload_logo_error_label: false,
            upload_messages: {
                january: {},
                february: {},
                march: {},
                april: {},
                may: {},
                june: {},
                july: {},
                august: {},
                september: {},
                october: {},
                november: {},
                december: {}
            },
            loading: false,
        }

        this.store = this.props.store.appState;
    };

    componentDidMount() {

        const self = this;
        let urlPath = self.props.history.location.pathname;
        document.body.style.background = '#275f84';

        if (urlPath.length < 1) {
            self.setState({url_ok: false});
            return;

        } else {

            if (urlPath.length < 0 || urlPath === '/upload-calendar' || urlPath === '/upload-calendar/') {
                self.setState({url_ok: false});
                return;

            } else {

                const fullUrl = PHOTOSELFIE_BASE_URL + urlPath;
                self.store.get_calendar_landing_page_data_by_url(fullUrl, function (res) {
                    if (res) {
                        self.store.handle_app_lang(res[0].lang);
                        self.setState({
                            language: res[0].lang,
                            url_ok: true
                        });
                    }
                });
            }
        }

        document.body.style.background = '#275f84';
    }

    handleSingleImageChange = (month, sponsor, logo, event) => {

        const self = this;
        event.preventDefault();
        let file = event.target.files[0];

        self.setState({loading: true});

        const photo_unique_token = uuidv4().substr(20, 4);
        let fileName = file.name.split(".");
        let ext = fileName.pop();
        let firstVal = fileName.join(".");
        let updatedFileName = firstVal + '_' + photo_unique_token + '.' + ext;
        let newFile = new File([file], updatedFileName);

        const valid_photo = self.validatePhotoSize(month, sponsor, logo, file, false);

        self.setState({errors: valid_photo.errors}, () => {

            if (logo) {
                self.setState({
                    ...self.state,
                    calendar_data: {
                        ...(self.state.calendar_data),
                        calendar_logo: {
                            file: newFile,
                            imagePreviewUrl: URL.createObjectURL(file)
                        }
                    }
                })

            } else {
                self.setState({
                    ...self.state,
                    calendar_data: {
                        ...(self.state.calendar_data),
                        [month]: {
                            ...(self.state.calendar_data[`${month}`]),
                            [sponsor]: {
                                file: newFile,
                                imagePreviewUrl: URL.createObjectURL(file)
                            }
                        }
                    }
                })
            }
        })

        if (valid_photo.valid) {
            
            let type = {};
            if (logo) {
                type = 'logo';
            } else if (sponsor) {
                type = 'sponsor';
            } else {
                //do nothing
            }


            self.setState({loading: true});

            //EVL
            self.store.upload_photo({file: newFile, cal_type: type, cal_month: month}, function (res) {

                if (res && res.success === true) {

                    //foto uploaded ok
                    if (type === 'logo') {
                        self.setState({loading: false, logo_uploaded_ok: true});

                    } else if (type === 'sponsor') {

                        self.setState({
                            loading: false,
                            upload_messages: {
                                ...self.state.upload_messages,
                                [month]: {
                                    ...self.state.upload_messages[month],
                                    [sponsor]: res.success
                                }
                            }
                        });
                    } else if (type === 'photo') {

                        
                    }
                    
                    self.setState({loading: false});
                        

                } else {
                    //foto uploaded ko
                    if (type === 'logo') {
                        self.setState({loading: false, logo_uploaded_ok: false, show_upload_logo_error_label: true});
                    }

                    self.setState({loading: false});
                }
            });

        } else {
            self.setState({loading: false});
        }

        event.target.value = null;
    }


    handleMultipleImageChange = (month, event) => {

        const self = this;
        event.preventDefault();

        let images = self.state.calendar_data[month].photos;
        if (event.target.files.length > 2 || (images.length + event.target.files.length > 2)) {
            self.setState({
                ...self.state,
                errors: {
                    ...(self.state.errors),
                    [month]: {
                        ...(self.state.errors[month]),
                        max_number_photos: true
                    }
                }
            })
        } else {

            for (let i = 0; i < event.target.files.length; i++) {

                let file = event.target.files[i];
                const photo_unique_token = uuidv4().substr(20, 4);
                let fileName = file.name.split(".");
                let ext = fileName.pop();
                let firstVal = fileName.join(".");
                let updatedFileName = firstVal + '_' + photo_unique_token + '.' + ext;
                
                let newFile = new File([file], updatedFileName);
                const valid_photo = self.validatePhotoSize(month, '', '', newFile, true);
            
                images.push(Object.assign({
                    'file': newFile,
                    'uploaded': false,
                    'imagePreviewUrl': URL.createObjectURL(file)
                }));

                self.setState({
                    ...self.state,
                    calendar_data: {
                        ...(self.state.calendar_data),
                        [month]: {
                            ...(self.state.calendar_data[`${month}`]),
                            photos: images
                        }
                    },
                    errors: {
                        ...self.state.errors,
                        [month]: {
                            ...(self.state.errors[month]),
                            errorsPhoto: valid_photo.errors[month].errorsPhoto,
                            max_number_photos: false,
                            missing_calendar_photos:false
                        }
                    }
                })
            }

            if (self.state.errors[month].errorsPhoto.length === 0) {
                //upload photos
                images.forEach((image) => {

                    if (image.uploaded === false) {
                        self.setState({loading: true});
                        self.store.upload_photo({
                            file: image.file,
                            cal_type: 'photo',
                            cal_month: month
                        }, function (res) {
                           
                            if (res && res.success === true) {
                                //foto uploaded ok
                                image.uploaded = true;
                                image.new_upload = false;
                                self.setState({
                                    ...self.state,
                                    upload_messages: {
                                        ...self.state.upload_messages,
                                        [month]: {
                                            ...self.state.upload_messages[month],
                                            all_photos: res.success
                                        }
                                    },
                                    loading: false
                                });
                            }
                        });
                    }
                })
            }

            event.target.value = null;
        }

    }

    removePhoto = (month, photo_to_be_removed, single_photo, sponsor, logo) => {

        if (logo) {

            const newState = {
                ...this.state,
                calendar_data: {
                    ...this.state.calendar_data,
                },
                errors: {
                    ...this.state.errors,
                    calendar_logo: {}
                },
                logo_uploaded_ok: false,
                show_upload_logo_error_label: false
            }
            delete newState.calendar_data.calendar_logo;
            this.setState({...newState})

        } else if (single_photo) {

            this.setState({
                ...this.state,
                calendar_data: {
                    ...(this.state.calendar_data),
                    [month]: {
                        ...(this.state.calendar_data[`${month}`]),
                        [sponsor]: Object.assign({})
                    }
                },
                errors: {
                    ...this.state.errors,
                    [month]: {}
                },
                upload_messages: {
                    ...this.state.upload_messages,
                    [month]: {
                        ...(this.state.upload_messages[`${month}`]),
                    }
                }
            })

        } else {

            let photos = this.state.calendar_data[`${month}`].photos;
            let errorsPhoto = this.state.errors[month].errorsPhoto;

            const photoIndex = photos.findIndex((photo) => {
                return photo.file.name === photo_to_be_removed.file.name;
            });
//			const errorIndex = errorsPhoto.findIndex((error) => {
//                return error === photo_to_be_removed.file.name
//            })


            let errorIndex = -1;
            if(errorsPhoto){
                errorIndex = errorsPhoto.findIndex((error) => {
                    return error === photo_to_be_removed.file.name
                });
            }

            if (photoIndex > -1) {
                photos.splice(photoIndex, 1);
            }
            if (errorIndex > -1) {
                errorsPhoto.splice(errorIndex, 1);
            }

            this.setState({
                ...this.state,
                calendar_data: {
                    ...(this.state.calendar_data),
                    [month]: {
                        ...(this.state.calendar_data[`${month}`]),
                        photos: photos,
                        photo_uploaded_ok: false,
                        show_upload_photo_error_label: false
                    }
                },
                errors: {
                    ...this.state.errors,
                    [month]: {
                        errorsPhoto: errorsPhoto
                    }
                },
                upload_messages: {
                    ...this.state.upload_messages,
                    [month]: {
                        ...(this.state.upload_messages[`${month}`]),
                    }
                }

            }, () => {
                let self = this;
                if (errorsPhoto.length === 0 && photos.length !== 0) {
                    self.setState({loading: true});
                    
                    photos.forEach((photo) => {
                    
                        if (photo.uploaded === false) {

                            self.store.upload_photo({
                                file: photo.file,
                                cal_type: 'photo',
                                cal_month: month
                            }, function (res) {
                                
                                // res.success = false;
                                if (res && res.success === true) {
                                    //foto uploaded ok
                                    photo.uploaded = true;
                                    self.setState({
                                        ...self.state,
                                        upload_messages: {
                                            ...self.state.upload_messages,
                                            [month]: {
                                                ...self.state.upload_messages[month],
                                                all_photos: res.success
                                            }
                                        },
                                        loading: false
                                    });
                                }
                            });
                        } else {
                            self.setState({loading: false});
                        }
                    })
                }

                //const valid_photo = this.validatePhotoSize(month,'','',photo.file,true);

            })

        }

    }

    handleFormValidation = () => {

        let calendar_data = this.state.calendar_data;
        let errors = this.state.errors;
        let form_is_valid = true;
        let errorsIndex = [];

        const array_of_months = [];

        this.state.months.filter(item => item !== "calendar_logo").forEach(key => array_of_months.push({
            month: key,
            month_data: calendar_data[key]
        }));

        array_of_months.forEach((single_month) => {

            if (!single_month.month_data.calendar_name.trim()) {
                errors[single_month.month].calendar_name = true;
                form_is_valid = false;
            }

            if (single_month.month_data.calendar_name.length > 26) {
                errors[single_month.month].calendar_name_max_length = true;
                form_is_valid = false;
            }

            if (single_month.month_data.description.length > 300) {
                errors[single_month.month].descrition_max_length = true;
                form_is_valid = false;
            }

            if (single_month.month_data.sponsor_1 && single_month.month_data.sponsor_1.file) {
                if (single_month.month_data.sponsor_1.file.size < calendar_sponsor_min_photo_size) {
                    errors[single_month.month].min_size_sponsor_1 = true;
                    form_is_valid = false;
                }

                if (single_month.month_data.sponsor_1.file.size > calendar_sponsor_max_photo_size) {
                    errors[single_month.month].max_size_sponsor_1 = true;
                    form_is_valid = false;
                }
            }

            if (single_month.month_data.sponsor_2 && single_month.month_data.sponsor_2.file) {
                if (single_month.month_data.sponsor_2.file.size < calendar_sponsor_min_photo_size) {
                    errors[single_month.month].min_size_sponsor_2 = true;
                    form_is_valid = false;
                }

                if (single_month.month_data.sponsor_2.file.size > calendar_sponsor_max_photo_size) {
                    errors[single_month.month].max_size_sponsor_2 = true;
                    form_is_valid = false;
                }
            }

            if (single_month.month_data.photos.length === 0) {
                errors[single_month.month].missing_calendar_photos = true;
                form_is_valid = false;
            }


            if (single_month.month_data.photos.some(photo => photo.file.size < calendar_min_photo_size)) {
                errors[single_month.month].min_size_photo_calendar = true;
                form_is_valid = false;
            }

            if (single_month.month_data.photos.some(photo => photo.file.size > calendar_max_photo_size)) {
                errors[single_month.month].max_size_photo_calendar = true;
                form_is_valid = false;
            }

            if (calendar_data.calendar_logo && calendar_data.calendar_logo.file) {
                if (calendar_data.calendar_logo.file.size < calendar_sponsor_min_photo_size) {
                    errors.calendar_logo.min_photo_size = true;
                    form_is_valid = false;
                }

                if (calendar_data.calendar_logo.file.size > calendar_sponsor_max_photo_size) {
                    errors.calendar_logo.max_photo_size = true;
                    form_is_valid = false;
                }
            }

            single_month.month_data.photos.forEach((photo, index) => {
                if (photo.file.size < calendar_min_photo_size || photo.file.size > calendar_max_photo_size) {
                    errorsIndex.push(photo.file.name)
                }
                errors[single_month.month].errorsPhoto = errorsIndex;
            })
        })
        this.setState({errors: errors});
        return form_is_valid;
    }

    saveCalendarData = () => {

        const self = this;
        const calendar_data = self.state.calendar_data;
        
        if (self.handleFormValidation()) {
            calendar_data.months = self.state.months;
            self.store.upload_calendar_data(calendar_data, function (res) {
                
                if (res && res.success) {
                    self.props.history.push('/confirm-upload-calendar');
                }
            });
        }
    }

    validatePhotoSize = (month, sponsor, logo, file, multiple) => {

        const self = this;
        let errors = this.state.errors;
        errors.calendar_logo = {};
        let errorsIndex;

        if (!logo.trim()) errorsIndex = self.state.errors[month].errorsPhoto ? self.state.errors[month].errorsPhoto : [];
        let valid = true;

        if (!logo.trim() && !multiple) {
            if (file.size < calendar_sponsor_min_photo_size) {
                errors[`${month}`][`min_size_${sponsor}`] = true;
                valid = false;
            } else {
                errors[`${month}`][`min_size_${sponsor}`] = false;
            }
            if (file.size > calendar_sponsor_max_photo_size) {
                errors[month][`max_size_${sponsor}`] = true;
                valid = false;
            } else {
                errors[month][`max_size_${sponsor}`] = false;
            }
        } else if (multiple) {

            if (file.size < calendar_min_photo_size || file.size > calendar_max_photo_size) {
                errorsIndex.push(file.name);
                errors[month].error_size_multiple_photos = true;
                valid = false;
            }
            errors[month].errorsPhoto = errorsIndex;
        } else {
            if (file.size < calendar_sponsor_min_photo_size) {
                errors.calendar_logo.error_photo_size = true;
                valid = false;
            }
            if (file.size > calendar_sponsor_max_photo_size) {
                errors.calendar_logo.error_photo_size = true;
                valid = false;
            }
        }

        return {errors, valid};
    }

    render() {
        const DEFAULT_TEXT = toJS(this.store.DEFAULT_TEXT);
        const {calendar_data, errors, url_ok, months, loading, upload_messages, logo_uploaded_ok, show_upload_logo_error_label} = this.state;

        return (
            <React.Fragment>
                {
                    url_ok
                        ?
                        <div className='main-div-calendar'>
                            <div className='akinda-logo-calendar'>
                                <img className='img-akindalogo-calendar' src={AkindaLogo} alt='AkindaLogo'/>
                            </div>
                            <div className='calendar-wrapper-div'>
                                <div>
                                    <img className='img-photoselfie' src={PhotoSelfie} alt='Selfie'/>
                                </div>
                                <div className='landing-page-enabled'>
                                    <div className='introduction' style={{paddingBottom: '3rem'}}>
                                        <div>
                                            <img className='img-photoselfie-logo' src={PhotoSelfieLogo}
                                                 alt='PhotoSelfie'/>
                                        </div>
                                        <span className='product-title'>{DEFAULT_TEXT.calendar}</span>
                                        <span style={{paddingTop: '12px'}}>{DEFAULT_TEXT.calendar_subtitle}</span>
                                    </div>

                                </div>
                                <div className='instruction'>
                                    <div className='instruction-wrapper' style={{paddingBottom: '3rem'}}>
                                        <span style={{
                                            paddingTop: '1rem',
                                            marginLeft: '40px',
                                            fontSize: '1rem',
                                            fontWeight:'bold',
                                            fontFamily:'HelveticaNeue'
                                        }}>{DEFAULT_TEXT.instruction}</span>
                                        <ol className='ordered-list'>
                                            <li className='list-item-calendar'>
                                                {DEFAULT_TEXT.calendar_instruction_nr1}
                                            </li>
                                            <li className='list-item-calendar'>
                                                {DEFAULT_TEXT.calendar_instruction_nr2}
                                            </li>
                                            <li className='list-item-calendar' style={{marginTop: "0.5rem"}}>
                                                {DEFAULT_TEXT.calendar_instruction_NB}
                                                <span className='mail_to'><a
                                                    href="mailto:info@akinda.com">{DEFAULT_TEXT.mail_to}</a></span>
                                            </li>

                                        </ol>
                                    </div>
                                </div>
                                <hr className='horizontal-line'/>

                                <div id='calendar_logo'>
                                    <div className='calendar-flex' style={{marginTop: '4.5rem'}}>
                                        <p className='month'>{DEFAULT_TEXT.calendar_logo}</p>
                                        <div/>
                                    </div>
                                    <div className='calendar-flex'>
                                        <div className='wrapper-labels'>
                                            <p className='label-paragraph'>{DEFAULT_TEXT.upload_logo}</p>
                                            {errors.calendar_logo.error_photo_size &&
                                            <p className='label-secondary-error'>{DEFAULT_TEXT.error_photo_size}</p>}
                                        </div>

                                        <div>
                                            <div className='sponsor-image'>
                                                {calendar_data.calendar_logo &&
                                                <div
                                                    className={errors.calendar_logo.error_photo_size ? 'wrapper-image-calendar-error' : 'wrapper-image-calendar'}>
                                                        <span className='remove-photo'
                                                              onClick={(event) => this.removePhoto('', '', '', '', true)}>x</span>
                                                    <img alt='...'
                                                         src={calendar_data.calendar_logo.imagePreviewUrl}/>
                                                </div>
                                                }
                                            </div>
                                            <label htmlFor='logo'>
                                                <div
                                                    className={calendar_data.calendar_logo ? 'button-wrapper-change-photo' : 'button-wrapper-add-photo'}>
                                                    {calendar_data.calendar_logo ? DEFAULT_TEXT.change_label : DEFAULT_TEXT.choose_button}
                                                </div>
                                            </label>
                                            <input type='file'
                                                   accept="image/*"
                                                   id='logo'
                                                   style={{display: 'none'}}
                                                   onChange={(event) => this.handleSingleImageChange('', '', 'logo', event)}/>
                                        </div>
                                    </div>


                                    <div className='calendar-flex'>
                                        <div/>
                                        <div>
                                            <p className={(errors.calendar_logo.min_photo_size || errors.calendar_logo.max_photo_size) ? 'min-max-file-upload-error' : 'min-max-file-upload'}>{DEFAULT_TEXT.sponsor_photo_size}</p>

                                            {
                                                logo_uploaded_ok &&
                                                <p className={(errors.calendar_logo.min_photo_size || errors.calendar_logo.max_photo_size) ? 'min-max-file-upload-error' : 'min-max-file-upload'}  style={{
                                                    color: 'green',
                                                    textAlign: 'center'
                                                }}>{DEFAULT_TEXT.photo_uploaded_ok}</p>

                                            }
                                            {
                                                show_upload_logo_error_label &&
                                                <p className={(errors.calendar_logo.min_photo_size || errors.calendar_logo.max_photo_size) ? 'min-max-file-upload-error' : 'min-max-file-upload'}>{DEFAULT_TEXT.photo_uploaded_ko}</p>
                                            }
                                        </div>

                                    </div>
                                    <hr className='horizontal-line'/>
                                </div>

                                <form>
                                    {
                                        months.map((month, index) => {
                                            return (
                                                <div key={index}>
                                                    <div id={month}>

                                                        <div className='calendar-flex' style={{marginTop: '4.5rem'}}>
                                                            <p className='month'>{DEFAULT_TEXT[month]}</p>
                                                        </div>

                                                        <div className='calendar-flex'>
                                                            <div>
                                                                <p className={errors[month].calendar_name ? 'label-paragraph-error' : 'label-paragraph'}>
                                                                    {DEFAULT_TEXT.insert_calendar_title}
                                                                    <span className='mandatory-symbol'>*</span>
                                                                </p>
                                                                {
                                                                    errors[month].calendar_name_max_length &&
                                                                    <p className='label-secondary-error'>{DEFAULT_TEXT.calendar_title_max_length}</p>
                                                                }
                                                            </div>

                                                            <input 
                                                                type='text'
                                                                className='calendar-input-title'
                                                                placeholder={DEFAULT_TEXT.calendar_title_max_length}
                                                                onChange={(event) => {
                                                                       this.setState({
                                                                           ...this.state,
                                                                           calendar_data: {
                                                                               ...(this.state.calendar_data),
                                                                               [month]: {
                                                                                   ...(this.state.calendar_data[month]),
                                                                                   calendar_name: event.target.value
                                                                               }
                                                                           },
                                                                           errors: {
                                                                               ...(this.state.errors),
                                                                               [month]: {}
                                                                           }
                                                                       })
                                                                }}
                                                            />
                                                        </div>

                                                        <div className='calendar-flex'>
                                                            <div>
                                                                <p className='label-paragraph'>{DEFAULT_TEXT.insert_calendar_description}</p>
                                                                {errors[month].descrition_max_length &&
                                                                <p className='label-secondary-error'>{DEFAULT_TEXT.calendar_description_max_length}</p>}
                                                            </div>
                                                            <textarea 
                                                                className='textarea-calendar'
                                                                placeholder={DEFAULT_TEXT.calendar_description_max_length}
                                                                onChange={(event) => {
                                                                          this.setState({
                                                                              ...this.state,
                                                                              calendar_data: {
                                                                                  ...(this.state.calendar_data),
                                                                                  [month]: {
                                                                                      ...(this.state.calendar_data[month]),
                                                                                      description: event.target.value
                                                                                  }
                                                                              },
                                                                              errors: {
                                                                                  ...(this.state.errors),
                                                                                  [month]: {}
                                                                              }
                                                                          })
                                                                }}
                                                            />
                                                        </div>

                                                        <div className='calendar-flex' style={{marginTop: '2rem'}}>
                                                            
                                                            <div className='wrapper-labels' >
                                                                <p className={errors[month].missing_calendar_photos ? 'label-paragraph-error' : 'label-paragraph'}>
                                                                    {DEFAULT_TEXT.upload_multiple_photos}
                                                                    <span className='mandatory-symbol'>*</span>
                                                                </p>
                                                                {
                                                                    (errors[month].errorsPhoto && errors[month].errorsPhoto.length !== 0) &&
                                                                    <p className='label-secondary-error'>{DEFAULT_TEXT.error_photo_size}</p>
                                                                }
                                                                {errors[month].max_number_photos &&
                                                                <p className='label-secondary-error'>{DEFAULT_TEXT.max_number_photos_error}</p>}
                                                            </div>

                                                            <div >
                                                                <div className='sponsor-image'>
                                                                    {
                                                                        calendar_data[month].photos && calendar_data[month].photos.length >= 1 && calendar_data[month].photos.map((photo, index) => {
                                                                            return <div key={index}
                                                                                        className={(errors[month].errorsPhoto && errors[month].errorsPhoto.includes(photo.file.name)) ? 'wrapper-image-calendar-error' : 'wrapper-image-calendar'}>
                                                                                <span className='remove-photo'
                                                                                      onClick={(event) => this.removePhoto(month, photo, false, '', '')}>x</span>
                                                                                <img alt='...'
                                                                                     src={photo.imagePreviewUrl}/>
                                                                            </div>
                                                                        })
                                                                    }
                                                                </div>
                                                                <label htmlFor={`${month}_multiple`}>
                                                                    <div
                                                                        className={calendar_data[month].photos && calendar_data[month].photos.length > 0 ? 'button-wrapper-change-photo' : 'button-wrapper-add-photo'}
                                                                        style={{backgroundColor: calendar_data[month].photos.length >= 2 ? '#ccc' : ''}}
                                                                    >
                                                                        {calendar_data[month].photos && calendar_data[month].photos.length > 0 ? DEFAULT_TEXT.add : DEFAULT_TEXT.choose_button }
                                                                    </div>
                                                                </label>
                                                                <input type='file'
                                                                       accept="image/*"
                                                                       multiple
                                                                       disabled={calendar_data[month].photos.length >= 2}
                                                                       id={`${month}_multiple`}
                                                                       style={{display: 'none'}}
                                                                       onChange={(event) => this.handleMultipleImageChange(month, event)}
                                                                />
                                                            </div>
                                                            
                                                        </div>
                                                       
                                                        <div className='calendar-flex'>
                                                            <div/>
                                                            <div>
                                                                <p className={(errors[month].error_size_multiple_photos) ? 'min-max-file-upload-error' : 'min-max-file-upload'}>{DEFAULT_TEXT.logo_photo_size}</p>

                                                                {
                                                                    (calendar_data[month].photos.length !== 0 && upload_messages[month].all_photos === true) &&
                                                                    <p className={(errors.calendar_logo.min_photo_size || errors.calendar_logo.max_photo_size) ? 'min-max-file-upload-error' : 'min-max-file-upload'}
                                                                       style={{
                                                                           color: 'green',
                                                                           textAlign: 'center'
                                                                       }}>{DEFAULT_TEXT.photo_uploaded_ok}</p>
                                                                }

                                                                {
                                                                    (calendar_data[month].photos.length !== 0 && upload_messages[month].all_photos === false) &&
                                                                    <p className={(errors.calendar_logo.min_photo_size || errors.calendar_logo.max_photo_size) ? 'min-max-file-upload-error' : 'min-max-file-upload'}
                                                                       style={{
                                                                           color: 'red',
                                                                           textAlign: 'center'
                                                                       }}>{DEFAULT_TEXT.photo_uploaded_ko}</p>
                                                                }

                                                            </div>
                                                        </div>

                                                        <div className='calendar-flex' style={{marginTop: '2rem'}}>
                                                            <div className='wrapper-labels'>
                                                                <p className='label-paragraph'>{DEFAULT_TEXT.upload_sponsor_1}</p>
                                                                {(errors[month].min_size_sponsor_1 || errors[month].max_size_sponsor_1) &&
                                                                <p className='label-secondary-error'>{DEFAULT_TEXT.error_photo_size}</p>}
                                                            </div>

                                                            <div>
                                                                <div className='sponsor-image'>
                                                                    {calendar_data[month].sponsor_1.file &&
                                                                        <div
                                                                            className={(errors[month].min_size_sponsor_1 || errors[month].max_size_sponsor_1) ? 'wrapper-image-calendar-error' : 'wrapper-image-calendar'} >
                                                                            <span 
                                                                                className='remove-photo'
                                                                                onClick={(event) => this.removePhoto(month, '', true, 'sponsor_1', '')}
                                                                            >x</span>
                                                                            <img 
                                                                                alt='preview sponsor 1'
                                                                                src={calendar_data[month].sponsor_1.imagePreviewUrl}
                                                                            />
                                                                        </div>
                                                                    }
                                                                </div>
                                                                <label htmlFor={`${month}_sponsor1`}>
                                                                    <div
                                                                        className={calendar_data[month].sponsor_1.file ? 'button-wrapper-change-photo' : 'button-wrapper-add-photo'}
                                                                        >
                                                                        {calendar_data[month].sponsor_1.file ? DEFAULT_TEXT.change_label : DEFAULT_TEXT.choose_button }
                                                                    </div>
                                                                </label>
                                                                <input 
                                                                    type='file'
                                                                    accept="image/*"
                                                                    id={`${month}_sponsor1`}
                                                                    style={{display: 'none'}}
                                                                    onChange={(event) => this.handleSingleImageChange(month, 'sponsor_1', '', event)}
                                                                />
                                                            </div>
                                                        </div>

                                                        <div className='calendar-flex'>
                                                            <div/>
                                                            <div>
                                                                <p className={(errors[month].min_size_sponsor_1 || errors[month].max_size_sponsor_1) ? 'min-max-file-upload-error' : 'min-max-file-upload'}>{DEFAULT_TEXT.sponsor_photo_size}</p>
                                                                {
                                                                    (calendar_data[month].sponsor_1.file && upload_messages[month].sponsor_1 === true) &&
                                                                    <p className={(errors.calendar_logo.min_photo_size || errors.calendar_logo.max_photo_size) ? 'min-max-file-upload-error' : 'min-max-file-upload'}
                                                                       style={{
                                                                           color: 'green',
                                                                           textAlign: 'center'
                                                                       }}>{DEFAULT_TEXT.photo_uploaded_ok}</p>

                                                                }
                                                                {
                                                                    (calendar_data[month].sponsor_1.file && upload_messages[month].sponsor_1 === false) &&
                                                                    <p className={(errors.calendar_logo.min_photo_size || errors.calendar_logo.max_photo_size) ? 'min-max-file-upload-error' : 'min-max-file-upload'}
                                                                       style={{
                                                                           color: 'red',
                                                                           textAlign: 'center'
                                                                       }}>{DEFAULT_TEXT.photo_uploaded_ko}</p>
                                                                }
                                                            </div>
                                                        </div>

                                                        <div className='calendar-flex' style={{marginTop: '2rem'}}>
                                                            <div className='wrapper-labels'>
                                                                <p className='label-paragraph'>{DEFAULT_TEXT.upload_sponsor_2}</p>
                                                                {(errors[month].min_size_sponsor_2 || errors[month].max_size_sponsor_2) &&
                                                                <p className='label-secondary-error'>{DEFAULT_TEXT.error_photo_size}</p>}
                                                            </div>

                                                            <div>
                                                                <div className='sponsor-image'>
                                                                    {calendar_data[month].sponsor_2.file &&
                                                                    <div
                                                                        className={(errors[month].min_size_sponsor_2 || errors[month].max_size_sponsor_2) ? 'wrapper-image-calendar-error' : 'wrapper-image-calendar'}>
                                                        <span className='remove-photo'
                                                              onClick={(event) => this.removePhoto(month, '', true, 'sponsor_2', '')}>x</span>
                                                                        <img alt='...'
                                                                             src={calendar_data[month].sponsor_2.imagePreviewUrl}/>
                                                                    </div>
                                                                    }
                                                                </div>
                                                                <label htmlFor={`${month}_sponsor_2`}>
                                                                    <div
                                                                        className={calendar_data[month].sponsor_2.file ? 'button-wrapper-change-photo' : 'button-wrapper-add-photo'}>
                                                                        {calendar_data[month].sponsor_2.file ? DEFAULT_TEXT.change_label : DEFAULT_TEXT.choose_button}
                                                                    </div>
                                                                </label>
                                                                <input type='file'
                                                                       accept="image/*"
                                                                       id={`${month}_sponsor_2`}
                                                                       style={{display: 'none'}}
                                                                       onChange={(event) => this.handleSingleImageChange(month, 'sponsor_2', '', event)}/>
                                                            </div>
                                                        </div>
                                                        <div className='calendar-flex'>
                                                            <div/>
                                                            <div>
                                                                <p className={(errors[month].min_size_sponsor_2 || errors[month].max_size_sponsor_2) ? 'min-max-file-upload-error' : 'min-max-file-upload'}>{DEFAULT_TEXT.sponsor_photo_size}</p>
                                                                {
                                                                    (calendar_data[month].sponsor_2.file && upload_messages[month].sponsor_2 === true) &&
                                                                    <p className={(errors.calendar_logo.min_photo_size || errors.calendar_logo.max_photo_size) ? 'min-max-file-upload-error' : 'min-max-file-upload'}
                                                                       style={{
                                                                           color: 'green',
                                                                           textAlign: 'center'
                                                                       }}>{DEFAULT_TEXT.photo_uploaded_ok}</p>

                                                                }
                                                                {
                                                                    (calendar_data[month].sponsor_2.file && upload_messages[month].sponsor_2 === false) &&
                                                                    <p className={(errors.calendar_logo.min_photo_size || errors.calendar_logo.max_photo_size) ? 'min-max-file-upload-error' : 'min-max-file-upload'}
                                                                       style={{color: 'red'}}>{DEFAULT_TEXT.photo_uploaded_ko}</p>
                                                                }
                                                            </div>
                                                        </div>
                                                        <hr className='horizontal-line'/>
                                                    </div>

                                                </div>
                                            )
                                        })
                                    }
                                    <div className='button-wrapper-send-photo'>
                                        <div className='button-send-photo'
                                             onClick={() => this.saveCalendarData()}>{DEFAULT_TEXT.send}</div>
                                    </div>
                                </form>
                            </div>

                            <div className='bottom-container '>
                                <p className='separator'/>
                            </div>
                        </div>
                        // : <h1></h1>
                        : ''
                }
                {
                    loading &&
                    <div style={{
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                        height: "100vh"
                    }}>
                        <CircularProgress style={{
                            color: "#e91e63",
                            position: 'fixed',
                            zIndex: 99,
                            top: 0,
                            left: 0,
                            right: 0,
                            bottom: 0,
                            margin: 'auto',
                            width: 50,
                            height: 50
                        }}/>
                    </div>
                }
            </React.Fragment>
        )
    }
}


export default UploadCalendar;



// WEBPACK FOOTER //
// ./src/views/Calendar/UploadCalendar.jsx